<template>
  <iColumn align="center">
    <iSubHeading
      variant="standard"
      align="center"
    >
      Let's get you set up. Enter your details below
    </iSubHeading>
    <iText v-if="signUpNote" data-test="deleted-account-sign-up-note">
      {{ signUpNote }}
    </iText>
    <iTextInput
      v-model="userAuthEmail"
      placeholder="Email"
      disabled
      width="fill"
      right-icon="pencil"
      @click-icon-right="goBackToEmailStep"
    />
    <iTextInput
      v-model="firstName"
      placeholder="First Name"
      width="fill"
      focus
    />
    <iTextInput
      v-model="lastName"
      placeholder="Last Name"
      width="fill"
    />
    <iTextInput
      v-model="password"
      placeholder="Password"
      width="fill"
      type="password"
    />
    <PasswordComplexity
      v-if="password"
      :password="password"
      @update:password="validatePasswordComplexity"
    />
    <iTextInput
      v-model="confirmPassword"
      placeholder="Confirm Password"
      width="fill"
      type="password"
      @enter="completeSignUp"
    />
    <iText v-if="signupErrorMessage" variant="error">
      {{ signupErrorMessage }}
    </iText>
    <iButton
      :is-loading="isLoading"
      loading-spinner-position="inside"
      :disabled="isLoading || !validPassword || !isSignupFormValid"
      @click="completeSignUp"
    >
      Continue
    </iButton>
    <iSpace :height="20" width="fill" />
    <PoweredByInspiration />
  </iColumn>
</template>

<script>
import PoweredByInspiration from "%/dynamic-component-editor/standard-pages/login-signup-page/join-publication/PoweredByInspiration.vue";
import { mapActions, mapState, mapWritableState } from "pinia";
import PasswordComplexity from "%/dynamic-component-editor/components/PasswordComplexity.vue";
import { useLoginSignupStore } from "%/dynamic-component-editor/stores/login-signup-store";

export default {
  name: "JoinPublicationSignUp",
  components: { PasswordComplexity, PoweredByInspiration },
  data() {
    return {
      validPassword: false,
      firstName: "",
      lastName: "",
      password: "",
      confirmPassword: "",
    };
  },
  computed: {
    ...mapWritableState(useLoginSignupStore, [
      "userAuthEmail",
      "userFlowSteps",
      "signupErrorMessage",
    ]),
    ...mapState(useLoginSignupStore, [
      "signUpNote",
      "isLoading",
    ]),
    isSignupFormValid() {
      return this.validateSignupFormData(
        this.firstName,
        this.lastName,
        this.userAuthEmail,
        this.password,
        this.confirmPassword,
      );
    },
  },
  mounted() {
    this.signupErrorMessage = "";
  },
  methods: {
    ...mapActions(useLoginSignupStore, [
      "signUpUser",
      "validateSignupFormData",
    ]),
    completeSignUp() {
      if (!this.isSignupFormValid) {
        return;
      }
      this.signUpUser(this.firstName, this.lastName, this.userAuthEmail, this.password, 1);
    },
    goBackToEmailStep() {
      this.userFlowSteps.pop();
    },
    validatePasswordComplexity(value) {
      this.validPassword = value;
    },
  },
};
</script>
